<div class="row frame-to-ship-list">
  <ng-container *ngFor="let shipItems of frameToShipItems; let i = index">
    <div class="col s12 m6 l3 mt-15">
      <div class="frame-to-ship-item">
        <div class="frame-items">
          <p><strong>Brand: </strong>{{ shipItems.brand }}</p>
          <p><strong>Style: </strong>{{ shipItems.style }}</p>
          <p><strong>Color: </strong>{{ shipItems.color }}</p>
          <p><strong>UPC: </strong>{{ shipItems.upc }}</p>
          <p><strong>Patient: </strong>{{ shipItems?.patientName }} {{ shipItems?.firstName || '' }} {{ shipItems?.lastName || ''}}</p>
          <p><strong>Rx Order ID: </strong>{{ shipItems.rxOrderId }}</p>
          <p><strong>Frame Condition: </strong>{{ shipItems?.frameCondition }}</p>
          <br />
          <br />
          <br />
          <br />
        </div>
        <div class="sticky-button">
          <button class="btn btn-primary" (click)="removeItem(i)">Remove From Shipping</button>
        </div>
      </div>
    </div>
  </ng-container>
</div>
